
import React from 'react'
import {
  Text, Button, StatusCircle, Spacer
} from 'components/atoms'
import { Tooltip } from 'components/molecules';
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { status as pageStatus } from 'context/EditorContext'

const Status = ({
  status,
  text,
  link,
}) => {
  const renderItem = () => (
    <ItemContent>
      <StatusCircle status={status} />
      {text && (
        <>
          <Spacer right="xs2" />
          <Text modifiers={['light', 'uppercase']}>{text}</Text>
        </>
      )
      }
    </ItemContent>
  )

  if (!link) {
    return (
      <Tooltip tooltip={<FormattedMessage id={`page.state.${status}`} />} placement="top">
        <ItemWrapper>
          {renderItem()}
        </ItemWrapper>
      </Tooltip>
    )
  }

  // todo fix link not going to correct language in english
  return (
    <Tooltip tooltip={<FormattedMessage id={`page.state.${status}`} />} placement="top">
      <ItemWrapper>
        <Link to={link}>
          <Button modifiers={['smaller', 'invisible', 'bgLighterSHover']}>
            {renderItem()}
          </Button>
        </Link>
      </ItemWrapper>
    </Tooltip>
  )
}

const ItemWrapper = styled.div`
  a {
    text-decoration: none;
  }
`

const ItemContent = styled.div`
  display: inline-flex;
  align-items: center;
`

Status.propTypes = {
  text: PropTypes.string,
  status: PropTypes.oneOf(Object.keys(pageStatus)).isRequired,
  link: PropTypes.string
}

Status.defaultProps = {
  text: null,
  link: null,
}

export default Status
